
import { mapGetters, mapActions } from 'vuex'
import ReviewTemplate from './review-template.vue'
import ReviewForm from './review-form.vue'
import { parseReviewsBreakdown } from '~/helpers/stamped/parseReviewsBreakdown'
import StampedReviews from '@/components/product-page/pdp-buybox/stamped-reviews.vue'
import Button from '@/components/buttons/Button.vue'
// import LoleSelect from '~/components/form/select/lole-select'
export default {
  components: {
    ReviewTemplate,
    ReviewForm,
    StampedReviews,
    Button,
    // LoleSelect,
  },
  inject: ['product', 'wording'],
  props: {
    page: {
      type: Number,
      required: true,
    },
    totalPages: {
      type: Number,
      required: true,
    },
    reviewsPerPage: {
      type: Number,
      required: true,
    },
    reviewsResults: {
      type: Array,
      required: true,
    },
    reviewsBreakdown: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      activeTab: 'reviews',
      product: this.product,
      wording: this.wording,
      reviewsSortBy: '',
    }
  },
  computed: {
    ...mapGetters({
      vxLeaveReviewIntent: 'pdp/getLeaveReviewIntent',
    }),
    reviewObjectReady() {
      return this.reviewsResults
    },
    averageScore() {
      if (this.aggregatedBreakdown.rating) {
        return parseFloat(this.aggregatedBreakdown.rating).toFixed(1)
      } else {
        return 0
      }
    },
    totalReviewCount() {
      return this.aggregatedBreakdown.count
    },
    aggregatedBreakdown() {
      return parseReviewsBreakdown(this.reviewsBreakdown)?.global
    },
  },
  watch: {
    vxLeaveReviewIntent(val) {
      if (val) {
        this.activeTab = 'reviewform'
        this.vxSetLeaveReviewIntent(false)
      }
    },
  },
  methods: {
    ...mapActions({
      vxSetLeaveReviewIntent: 'pdp/setLeaveReviewIntent',
    }),
    setTab(tab) {
      this.activeTab = tab
    },
  },
}
